import { GlobalConfig } from '../config'
import { URLQueries } from './url_query'
import { GlobalEnv } from './index'
import { getToken, normalizeLoginInfo } from '../../js/token-guard'

import {
  canIUse,
  setLoginConfig,
  login as webxLogin,
  isLogin,
  xenv,
  is,
  storage,
} from '@didi/webx-js'

export const getFromQuery = () => {
  const token = getToken()
  const uid = URLQueries.getQuery('uid')

  // if (token && token !== '__token__' && !Number.isNaN(Number(uid))) {
  //   return {
  //     token,
  //     uid,
  //   }
  // }
  // 原逻辑的问题：
  // 内嵌H5， 当xenv为非H5时会拉起登录通用中间页面登录返回来时， 只会给到token, 此时没有uid, 按照此逻辑存在死循环
  // 因此解决方案， 当内嵌H5的环境下，xenv为非H5时，不会强制uid
  const urlVal = {}
  if (token && token !== '__token__') {
    urlVal.token = token
  }
  if (!Number.isNaN(Number(uid))) {
    urlVal.uid = uid
  }
  // token 已在页面入口清洗进 sessionStorage，后续不再从 URL query 读取。
  console.log('is(miniprogram,hwfastapp)=====', is('miniprogram,hwfastapp'))
  if (urlVal.token) {
    return urlVal
  }
}

let isLoginCalled = false

// 作用： 在url中拿token的情况，调用isLogin 缓存passport登录信息
export const callIsLogin = () => {
  if (!isLoginCalled) {
    isLogin().catch(() => {})
    isLoginCalled = true
  }
}

/**
 * 获取用户登录信息
 */
export const getLoginInfo = (options = {}) =>
  new Promise(resolve => {
    const fromQuery = getFromQuery()
    if (fromQuery) {
      const loginInfo = normalizeLoginInfo(fromQuery)
      storage.userInfo = loginInfo
      resolve(loginInfo)
      return
    }
    const _options = Object.assign(
      {
        needLogin: false,
        needReload: false,
        fail_url: window.location.href,
        // 注意，在调用中间页登录-未登录情况下的情况-如果使用fail_url 需处理死循环
      },
      options
    )
    canIUse('setLoginConfig') && setLoginConfig(GlobalConfig.LoginConfig)
    // 内嵌H5调用 isLogin会存在拿到老账号的问题, 与小程序登录的账号不一致，进而导致购买账号出错
    // login 会直接拉起登录，因此在调用时，只有在需要登录时，才拉登录
    // 控制下支持的 内嵌H5， 不是所有的小程序都支持中间页登录 （webxjs会跳webx-mp中间页，但小程序并未按照标准接入，会导致拉不起来登录）
    if (
      is('miniprogram') &&
      ['wxmp', 'dymp', 'alimp', 'hywxmp', 'cralimp'].indexOf(xenv()) !== -1
    ) {
      return goLogin(_options).then(res => {
        // console.log('----【getLoginInfo】2-', res)
        resolve(res)
      })
    } else {
      return isLogin()
        .catch(() => goLogin(_options))
        .then(res => {
          // console.log('----【getLoginInfo】1-', res)
          resolve(res)
        })
    }
  })

function goLogin(options = {}) {
  const Dres = {
    token: '',
    phone: '',
    uid: '',
  }
  if (!options.fail_url) {
    options.fail_url = window.location.href
  }
  if (options.needLogin) {
    return login(options)
      .then(res => {
        // console.log('【getLoginInfo】', res)
        isLoginCalled = true
        return res
      })
      .catch(err => {
        console.log('【getLoginInfo]-err', err)
        return Promise.resolve(Dres)
      })
  } else {
    return Promise.resolve(Dres)
  }
}

/**
 * webx 登录
 */
export const login = (options = {}) =>
  new Promise((resolve, reject) => {
    if (!options.fail_url) {
      options.fail_url = window.location.href
    }
    const opts = Object.assign({ needReload: true }, options)
    webxLogin(opts)
      .then(res => {
        const loginInfo = normalizeLoginInfo(res)
        GlobalEnv.loginInfo = loginInfo
        if (GlobalEnv.loginInfo.token) {
          try {
            window.Omega?.setConfig?.({ forbidReport: false })
          } catch (error) {}
        }
        ;['h5', 'hypassenger'].includes(xenv()) &&
          opts.needReload &&
          window.location.reload()
        resolve(loginInfo)
      })
      .catch(err => {
        reject(err)
      })
  })
